import { useNavigate } from "react-router-dom";

export type AppRoutes =
  | "/"
  | "/processes"
  | "/processes/new"
  | `/processes/edit/${number}`
  | "/delay-management"
  | "/danger-zones"
  | "/management-report";

export const useSafeNavigate = () => {
  const navigate = useNavigate();

  const wrappedNavigate = (to: AppRoutes) => navigate(to);

  return wrappedNavigate;
};
